<div class=" grid-container">
  @if (zeroAccessorialCount) {
    <legend class="usa-legend usa-legend--medium">There are no accessorials to display
    </legend>
  }
  @if (!redirectedFromBol) {
    <legend class="usa-legend usa-legend--large" class="usa-legend usa-legend--large">
    Accessorials</legend>
  }
  @if (!redirectedFromBol) {
    <legend class="usa-legend usa-legend--medium">Book Shipments Id - {{ this.bookShipmentId }}
    </legend>
  }
  <form id="hhgShipmentAccessorialForm" [formGroup]="hhgShipmentAccessorialForm">
    @if (!redirectedFromBol && !isCarrierView) {
      <div class="grid-gap-1 grid-row padding-bottom-2">
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
          <label for="accessorial-list" class="usa-label">List of available Accessorial Codes and
          Descriptions</label>
          <select id="accessorial-list" class="usa-select maxw-full" formControlName="accessorialAvailableList" (change)="addAccessorialList($event)">
            <option value='' selected>None</option>
            @for (aList of accessorialList; track aList) {
              <option>{{aList.accessorialCode}} -
                {{aList.accessorialDesc}}
              </option>
            }
          </select>
        </div>
      </div>
    }
    <div class="usa-accordion usa-accordion--bordered">
      @if (excessValuationDisplay) {
        <h4 class="usa-accordion__heading">
          <button class="usa-accordion__button" aria-expanded="true" aria-controls="b-a1">
            Excess Valuation
          </button>
        </h4>
      }
      @if (excessValuationDisplay) {
        <div id="b-a1" formGroupName="excessValuation" class="usa-accordion__content usa-prose">
          <div class="grid-row grid-gap-1">
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
              <label class="usa-label text-bold">Released valuation at {{releasedValuationWeight}} lbs
              is</label>
              <label class="usa-label">{{accessorialInfo.releasedValuationCost | currency}}</label>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
              <label for="req-total-valuation" class="usa-label ">Enter the requested total valuation <span style="color: red;">*</span> </label>
              <input type="text" placeholder="Enter Value Here" id="req-total-valuation" appNumbersOnly class="usa-input maxw-full" formControlName="reqTotalValuation" (change)="setShipAuth('excessValuation', 'excessValuationShipAuthorize', 'excessValuationTspAuthorize')">
              @for (validation of validationMessages.reqTotalValuation; track validation) {
                @if (hhgShipmentAccessorialForm.get('excessValuation').get('reqTotalValuation').hasError(validation.type) && (hhgShipmentAccessorialForm.get('excessValuation').get('reqTotalValuation').dirty || hhgShipmentAccessorialForm.get('excessValuation').get('reqTotalValuation').touched)) {
                  <div class="define-text-secondary">
                    <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                      <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                    </svg> {{validation.message}}
                  </div>
                }
              }
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
              <label class="usa-label text-bold">190-1 Cost of excess Valuation for transportation</label>
              <label class="usa-label">{{excessCostValTransport | currency}}</label>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
              <label class="usa-label text-bold">190-1 Cost of excess Valuation for storage in transit
              </label>
              <label class="usa-label">{{excessCostValStorage | currency}}</label>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
              <label class="usa-label text-bold">Total Cost of Excess Valuation</label>
              <label class="usa-label">{{totalCostExcessValuation | currency}}</label>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
              <label for="excess-ship-auth" class="usa-label">Shipper Authorization</label>
              <select id="excess-ship-auth" class="usa-select maxw-full" [attr.disabled]="!isCarrierView?null:true" formControlName="excessValuationShipAuthorize">
                <option value=null selected>None</option>
                @for (saList of shipperAuthorization; track saList) {
                  <option [ngValue]="saList">
                  {{saList}}</option>
                }
              </select>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
              <label class="usa-label">TSP Acceptance</label>
              <select id="excess-tsp-auth" class="maxw-full usa-select" [attr.disabled]="isCarrierView?null:true" formControlName="excessValuationTspAuthorize">
                <option value=null selected>None</option>
                @for (tspList of tspAuthorization; track tspList) {
                  <option [ngValue]="tspList">
                  {{tspList}}</option>
                }
              </select>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
              <label for="excess-text-btn" class="usa-label">Message</label>
              <button type="button" class="usa-button" id="excess-text-btn" (click)="openAdditionalInfo('Excess Valuation', 48)">Notes
              </button>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
              @if (!redirectedFromBol && !isCarrierView) {
                <button type="button" class="usa-button usa-button--secondary" (click)="deleteAccessorialCode('Excess Valuation')">Delete</button>
              }
            </div>
          </div>
        </div>
      }
    <!-- </div> -->

    @if (exclusiveUseOfVehiclesDisplay) {
      <h4 class="usa-accordion__heading">
        <button class="usa-accordion__button" aria-expanded="true" aria-controls="b-a3">
          5-Exclusive Use of Vehicles
        </button>
      </h4>
    }
    @if (exclusiveUseOfVehiclesDisplay) {
      <div id="b-a3" formGroupName="exclusiveUseOfVehicles" class="usa-accordion__content usa-prose">
        <div class="grid-row grid-gap-1">
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
            <label for="eov-ship-auth" class="usa-label">Shipper Authorization</label>
            <select id="eov-ship-auth" class="usa-select maxw-full" formControlName="eovShipAuthorize" [attr.disabled]="!isCarrierView?null:true">
              <option value=null selected>None</option>
              @for (saList of shipperAuthorization; track saList) {
                <option [ngValue]="saList">
                {{saList}}</option>
              }
            </select>
          </div>
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
            <label for="eov-ship-auth" class="usa-label">TSP Acceptance</label>
            <select id="eov-tsp-auth" class="usa-select maxw-full" formControlName="eovTspAuthorize" [attr.disabled]="isCarrierView?null:true">
              <option value=null selected>None</option>
              @for (tspList of tspAuthorization; track tspList) {
                <option [ngValue]="tspList">
                {{tspList}}</option>
              }
            </select>
          </div>
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
            <label for="eov-other-text-btn" class="usa-label">Message</label>
            <button type="button" class="usa-button" id="eov-other-text-btn" (click)="openAdditionalInfo('Exclusive Use of Vehicles', 36)">Notes</button>
          </div>
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12 padding-top-2">
            @if (!redirectedFromBol && !isCarrierView) {
              <button type="button" class="usa-button usa-button--secondary" (click)="deleteAccessorialCode('Exclusive Vehicle Use')">Delete</button>
            }
          </div>
        </div>
      </div>
    }

    @if (storageTransitDisplay) {
      <h4 class="usa-accordion__heading">
        <button class="usa-accordion__button" aria-expanded="true" aria-controls="b-a2">
          Storage in Transit
        </button>
      </h4>
    }
    @if (storageTransitDisplay) {
      <div id="b-a2" formGroupName="storageInTransit" class="usa-accordion__content usa-prose">
        <div class="grid-row grid-gap-1">
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
            <div class="grid-row grid-gap-1">
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <h4>SIT at Origin</h4>
              </div>
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <legend class="usa-legend usa-legen--medium">185- Storage</legend>
              </div>
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <label for="origin-no-days" class="usa-label">Select No of Days</label>
                <select id="origin-no-days" class="maxw-full usa-select" formControlName="originNoDays" (change)="onSitChange()">
                  <option value=null selected>None</option>
                  @for (daList of noDaysList; track daList) {
                    <option [ngValue]="daList">{{daList}}
                    </option>
                  }
                </select>
              </div>
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <label for="origin-storage-sit" class="usa-label text-bold">Origin Storage SIT
                Cost</label>
                <label class="usa-label">{{accessorialInfo.originStorageCost |
                currency}}</label>
              </div>
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <label class="usa-label text-bold">210A - P/D SIT 50 miles or less</label>
                <label class="usa-label">{{accessorialInfo.originsitMilesCost |
                currency}}</label>
              </div>
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <label for="origin-ship-auth" class="usa-label">Shipper Authorization</label>
                <select id="origin-ship-auth" class="usa-select maxw-full" [attr.disabled]="!isCarrierView?null:true" formControlName="originShipAuthorize">
                  <option value=null selected>None</option>
                  @for (saList of shipperAuthorization; track saList) {
                    <option [ngValue]="saList">
                      {{saList}}
                    </option>
                  }
                </select>
              </div>
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <label for="tsp-acceptance" class="usa-label">TSP Acceptance</label>
                <select id="origin-tsp-auth" class="maxw-full usa-select" [attr.disabled]="isCarrierView?null:true" formControlName="originTspAuthorize">
                  <option value=null selected>None</option>
                  @for (tspList of tspAuthorization; track tspList) {
                    <option [ngValue]="tspList">{{tspList}}
                    </option>
                  }
                </select>
              </div>
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <label for="sit-origin-text-btn" class="usa-label">Message</label>
                <button type="button" class="usa-button" id="sit-origin-text-btn" (click)="openAdditionalInfo('Storage In Transit Origin', 46)">Notes</button>
              </div>
            </div>
          </div>
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
            <div class="grid-row grid-gap-1">
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <h4>SIT at Destination</h4>
              </div>
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <legend class="usa-legend usa-legen--medium">185- Storage</legend>
              </div>
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <label for="dest-no-days" class="usa-label">Select No of Days</label>
                <select id="dest-no-days" class="maxw-full usa-select" formControlName="destNoDays" (change)="onSitChange()">
                  <option value=null selected>None</option>
                  @for (daList of noDaysList; track daList) {
                    <option [ngValue]="daList">{{daList}}
                    </option>
                  }
                </select>
              </div>
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <label for="storage-sit-cost" class="usa-label text-bold">Storage SIT Cost</label>
                <label class="usa-label">{{accessorialInfo.destStorageCost | currency}}</label>
              </div>
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <label class="usa-label text-bold">210A - P/D SIT 50 miles or less</label>
                <label class="usa-label">{{accessorialInfo.destsitMilesCost | currency}}</label>
              </div>
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <label for="dest-ship-auth" class="usa-label">Shipper Authorization</label>
                <select id="dest-ship-auth" class="maxw-full usa-select" [attr.disabled]="!isCarrierView?null:true" formControlName="destShipAuthorize">
                  <option value=null selected>None</option>
                  @for (saList of shipperAuthorization; track saList) {
                    <option [ngValue]="saList">
                      {{saList}}
                    </option>
                  }
                </select>
              </div>
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <label for="tsp-acceptance" class="usa-label">TSP Acceptance</label>
                <select id="dest-tsp-auth" class="usa-select maxw-full" [attr.disabled]="isCarrierView?null:true" formControlName="destTspAuthorize">
                  <option value=null selected>None</option>
                  @for (tspList of tspAuthorization; track tspList) {
                    <option [ngValue]="tspList">{{tspList}}
                    </option>
                  }
                </select>
              </div>
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <label for="sit-dest-text-btn" class="usa-label">Message</label>
                <button type="button" class="usa-button" id="sit-dest-text-btn" (click)="openAdditionalInfo('Storage In Transit Destination', 49)">Notes</button>
              </div>
            </div>
          </div>
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
            <label class="usa-label text-bold">Total SIT Charge</label>
            <label class="usa-label">{{accessorialInfo.totalSitCharge | currency}}</label>
          </div>
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12 padding-top-2">
            @if (!redirectedFromBol && !isCarrierView) {
              <button type="button" class="usa-button usa-button--secondary" (click)="deleteAccessorialCode('Storage In Transit')">Delete</button>
            }
          </div>
        </div>
      </div>
    }
  <!-- </div> -->

  <!-- expeditedService -->
  @if (expeditedServiceDisplay) {
    <h4 class="usa-accordion__heading">
      <button class="usa-accordion__button" aria-expanded="true" aria-controls="expeditedServiceDisplay">
        5-Expedited Services
      </button>
    </h4>
  }
  @if (expeditedServiceDisplay) {
    <div id="expeditedServiceDisplay" formGroupName="expeditedService" class="usa-accordion__content usa-prose">
      <div class="grid-gap-1 grid-row">
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
          <label for="exp-serv-ship-auth" class="usa-label">Shipper Authorization</label>
          <select id="exp-serv-ship-auth" class="maxw-full usa-select" formControlName="exServShipAuthorize" [attr.disabled]="!isCarrierView?null:true">
            <option value=null selected>None</option>
            @for (saList of shipperAuthorization; track saList) {
              <option [ngValue]="saList">
              {{saList}}</option>
            }
          </select>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
          <label class="usa-label">TSP Acceptance </label>
          <select id="exp-serv-tsp-auth" class="maxw-full usa-select" formControlName="exServTspAuthorize" [attr.disabled]="isCarrierView?null:true">
            <option value=null selected>None</option>
            @for (tspList of tspAuthorization; track tspList) {
              <option [ngValue]="tspList">
              {{tspList}}</option>
            }
          </select>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
          <label for="exp-other-text-btn" class="usa-label">Message</label>
          <button type="button" class="usa-button" id="exp-other-text-btn" (click)="openAdditionalInfo('Expedited Service', 37)">Notes</button>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12  padding-top-2">
          @if (!redirectedFromBol && !isCarrierView) {
            <button type="button" class="usa-button usa-button--secondary" (click)="deleteAccessorialCode('Expedited Service')">Delete</button>
          }
        </div>
      </div>
    </div>
  }
  <!--END: expeditedService -->

  <!-- travelTimeDisplay -->
  @if (travelTimeDisplay) {
    <h4 class="usa-accordion__heading">
      <button class="usa-accordion__button" aria-expanded="true" aria-controls="travelTimeDisplay">
        59-Travel Time - Extra Driver
      </button>
    </h4>
  }
  @if (travelTimeDisplay) {
    <div id="travelTimeDisplay" formGroupName="travelTime" class="usa-accordion__content usa-prose">
      <div class="grid-row grid-gap-1">
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
          <label for="tt-ship-auth" class="usa-label">Shipper Authorization</label>
          <select id="tt-ship-auth" class="maxw-full usa-select" formControlName="ttShipAuthorize" [attr.disabled]="!isCarrierView?null:true">
            <option value=null selected>None</option>
            @for (saList of shipperAuthorization; track saList) {
              <option [ngValue]="saList">
              {{saList}}</option>
            }
          </select>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
          <label class="usa-label">TSP Acceptance </label>
          <select id="tt-tsp-auth" class="maxw-full usa-select" formControlName="ttTspAuthorize" [attr.disabled]="isCarrierView?null:true">
            <option value=null selected>None</option>
            @for (tspList of tspAuthorization; track tspList) {
              <option [ngValue]="tspList">
              {{tspList}}</option>
            }
          </select>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
          <label for="tt-other-text-btn" class="usa-label">Message</label>
          <button type="button" class="usa-button" id="tt-other-text-btn" (click)="openAdditionalInfo('Travel Time', 39)">Notes</button>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12 padding-top-2">
          @if (!redirectedFromBol && !isCarrierView) {
            <button type="button" class="usa-button usa-button--secondary" (click)="deleteAccessorialCode('Travel Time')">Delete</button>
          }
        </div>
      </div>
    </div>
  }
  <!-- END: travelTimeDisplay -->

  <!-- debrisRemoval -->
  @if (debrisRemovalDisplay) {
    <h4 class="usa-accordion__heading">
      <button class="usa-accordion__button" aria-expanded="true" aria-controls="debrisRemovalDisplay">
        105D-Debris Removal
      </button>
    </h4>
  }
  @if (debrisRemovalDisplay) {
    <div id="debrisRemovalDisplay" formGroupName="debrisRemoval" class="usa-accordion__content usa-prose">
      <div class="grid-row grid-gap-1">
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
          <label for="dr-ship-auth" class="usa-label">Shipper Authorization</label>
          <select id="dr-ship-auth" class="maxw-full usa-select" formControlName="drShipAuthorize" [attr.disabled]="!isCarrierView?null:true">
            <option value=null selected>None</option>
            @for (saList of shipperAuthorization; track saList) {
              <option [ngValue]="saList">
              {{saList}}</option>
            }
          </select>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
          <label class="usa-label">TSP Acceptance</label>
          <select id="dr-tsp-auth" class="maxw-full usa-select" formControlName="drTspAuthorize" [attr.disabled]="isCarrierView?null:true">
            <option value=null selected>None</option>
            @for (tspList of tspAuthorization; track tspList) {
              <option [ngValue]="tspList">
              {{tspList}}</option>
            }
          </select>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
          <label for="dr-other-text-btn" class="usa-label">Message</label>
          <button type="button" class="usa-button" id="dr-other-text-btn" (click)="openAdditionalInfo('Debris Removal', 40)">Notes</button>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12 padding-top-2">
          @if (!redirectedFromBol && !isCarrierView) {
            <button type="button" class="usa-button usa-button--secondary" (click)="deleteAccessorialCode('Debris Removal')">Delete</button>
          }
        </div>
      </div>
    </div>
  }
  <!-- END:debrisRemoval -->

  <!-- extraLabor -->
  @if (extraLaborDisplay) {
    <h4 class="usa-accordion__heading">
      <button class="usa-accordion__button" aria-expanded="true" aria-controls="extraLaborDisplay">
        120-Extra Labor
      </button>
    </h4>
  }
  @if (extraLaborDisplay) {
    <div id="extraLaborDisplay" formGroupName="extraLabor" class="usa-accordion__content usa-prose">
      <div class="grid-row grid-gap-1">
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
          <label for="ext-labor-ship-auth" class="usa-label">Shipper Authorization</label>
          <select id="ext-labor-ship-auth" class="maxw-full usa-select" [attr.disabled]="!isCarrierView?null:true" formControlName="extLaborShipAuthorize">
            <option value=null selected>None</option>
            @for (saList of shipperAuthorization; track saList) {
              <option [ngValue]="saList">
              {{saList}}</option>
            }
          </select>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
          <label class="usa-label">TSP Acceptance </label>
          <select id="ext-labor-tsp-auth" class="usa-select maxw-full" [attr.disabled]="isCarrierView?null:true" formControlName="extLaborTspAuthorize">
            <option value=null selected>None</option>
            @for (tspList of tspAuthorization; track tspList) {
              <option [ngValue]="tspList">
              {{tspList}}</option>
            }
          </select>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
          <label for="ext-labor-text-btn" class="usa-label">Message</label>
          <button type="button" class="usa-button" id="ext-laborother-text-btn" (click)="openAdditionalInfo('Extra Labor', 41)">Notes</button>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12 padding-top-2">
          @if (!redirectedFromBol && !isCarrierView) {
            <button type="button" class="usa-button usa-button--secondary" (click)="deleteAccessorialCode('Extra Labor')">Delete</button>
          }
        </div>
      </div>
    </div>
  }
  <!-- END: extraLabor -->

  <!-- shuttleService -->
  @if (shuttleServiceDisplay) {
    <h4 class="usa-accordion__heading">
      <button class="usa-accordion__button" aria-expanded="true" aria-controls="shuttleServiceDisplay">
        125-Shuttle Service
      </button>
    </h4>
  }
  @if (shuttleServiceDisplay) {
    <div id="shuttleServiceDisplay" formGroupName="shuttleService" class="usa-accordion__content usa-prose">
      <div class="grid-row grid-gap-1">
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
          <label for="ss-ship-auth" class="usa-label">Shipper Authorization</label>
          <select id="ss-ship-auth" class="maxw-full usa-select" formControlName="sServiceShipAuthorize" [attr.disabled]="!isCarrierView?null:true">
            <option value=null selected>None</option>
            @for (saList of shipperAuthorization; track saList) {
              <option [ngValue]="saList">
              {{saList}}</option>
            }
          </select>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
          <label class="usa-label">TSP Acceptance </label>
          <select id="ss-tsp-auth" class="maxw-full usa-select" formControlName="sServiceTspAuthorize" [attr.disabled]="isCarrierView?null:true">
            <option value=null selected>None</option>
            @for (tspList of tspAuthorization; track tspList) {
              <option [ngValue]="tspList">
              {{tspList}}</option>
            }
          </select>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
          <label for="ss-other-text-btn" class="usa-label">Message</label>
          <button type="button" class="usa-button" id="ss-other-text-btn" (click)="openAdditionalInfo('Shuttle Service', 42)">Notes</button>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12 padding-top-2">
          @if (!redirectedFromBol && !isCarrierView) {
            <button type="button" class="usa-button usa-button--secondary" (click)="deleteAccessorialCode('Shuttle Service')">Delete</button>
          }
        </div>
      </div>
    </div>
  }
  <!-- END: shuttleService -->

  <!-- bulkyArticles -->
  @if (bulkyArticlesDisplay) {
    <h4 class="usa-accordion__heading">
      <button class="usa-accordion__button" aria-expanded="true" aria-controls="bulkyArticlesDisplay">
        130-Bulky Articles
      </button>
    </h4>
  }
  @if (bulkyArticlesDisplay) {
    <div id="bulkyArticlesDisplay" formGroupName="bulkyArticles" class="usa-accordion__content usa-prose">
      <div class="grid-row grid-gap-1">
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
          <label for="ba-ship-auth" class="usa-label">Shipper Authorization</label>
          <select id="ba-ship-auth" class="maxw-full usa-select" formControlName="baShipAuthorize" [attr.disabled]="!isCarrierView?null:true">
            <option value=null selected>None</option>
            @for (saList of shipperAuthorization; track saList) {
              <option [ngValue]="saList">
              {{saList}}</option>
            }
          </select>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
          <label class="usa-label">TSP Acceptance </label>
          <select id="ba-tsp-auth" class="maxw-full usa-select" formControlName="baTspAuthorize" [attr.disabled]="isCarrierView?null:true">
            <option value=null selected>None</option>
            @for (tspList of tspAuthorization; track tspList) {
              <option [ngValue]="tspList">
              {{tspList}}</option>
            }
          </select>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
          <label for="ba-other-text-btn" class="usa-label">Message</label>
          <button type="button" class="usa-button" id="ba-other-text-btn" (click)="openAdditionalInfo('Bulky Articles', 43)">Notes</button>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
          @if (!redirectedFromBol && !isCarrierView) {
            <button type="button" class="usa-button usa-button--secondary" (click)="deleteAccessorialCode('Bulky Articles')">Delete</button>
          }
        </div>
      </div>
    </div>
  }
  <!-- END: bulkyArticles -->

  <!-- exportImportCharge -->
  @if (exportImportChargeDisplay) {
    <h4 class="usa-accordion__heading">
      <button class="usa-accordion__button" aria-expanded="true" aria-controls="exportImportChargeDisplay">
        145-Export or Import Charge - Canada
      </button>
    </h4>
  }
  @if (exportImportChargeDisplay) {
    <div id="exportImportChargeDisplay" formGroupName="exportImportCharge" class="usa-accordion__content usa-prose">
      <div class="grid-gap-1 grid-row">
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
          <label for="ei-ship-auth" class="usa-label">Shipper Authorization</label>
          <div class="hhg-accessorial-row-height">
            <select id="ei-ship-auth" class="maxw-full usa-select" formControlName="eiChargeShipAuthorize" [attr.disabled]="!isCarrierView?null:true">
              <option value=null selected>None</option>
              @for (saList of shipperAuthorization; track saList) {
                <option [ngValue]="saList">
                {{saList}}</option>
              }
            </select>
          </div>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
          <label class="usa-label">TSP Acceptance </label>
          <select id="ei-tsp-auth" class="maxw-full usa-select" formControlName="eiChargeTspAuthorize" [attr.disabled]="isCarrierView?null:true">
            <option value=null selected>None</option>
            @for (tspList of tspAuthorization; track tspList) {
              <option [ngValue]="tspList">
              {{tspList}}</option>
            }
          </select>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
          <label for="ei-other-text-btn" class="usa-label">Message</label>
          <div class="hhg-accessorial-row-height">
            <button type="button" class="usa-button" id="ei-other-text-btn" (click)="openAdditionalInfo('Export or Import Charge (Canada)', 44)">Notes</button>
          </div>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12 padding-top-2">
          @if (!redirectedFromBol && !isCarrierView) {
            <button type="button" class="usa-button usa-button--secondary" (click)="deleteAccessorialCode('Export Import Charge')">Delete</button>
          }
        </div>
      </div>
    </div>
  }
  <!-- END: exportImportCharge -->

  <!-- pickupDeliveryHol -->
  @if (pickupDeliveryHolDisplay) {
    <h4 class="usa-accordion__heading">
      <button class="usa-accordion__button" aria-expanded="true" aria-controls="pickupDeliveryHolDisplay">
        175-Pickup and/or Delivery Saturdays, Sundays or Holidays
      </button>
    </h4>
  }
  @if (pickupDeliveryHolDisplay) {
    <div id="pickupDeliveryHolDisplay" formGroupName="pickupDeliveryHol" class="usa-accordion__content usa-prose">
      <div class="grid-row grid-gap-1">
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
          <label for="pd-hol-ship-auth" class="usa-label">Shipper Authorization</label>
          <select id="pd-hol-ship-auth" class="maxw-full usa-select" formControlName="pdHolShipAuthorize" [attr.disabled]="!isCarrierView?null:true">
            <option value=null selected>None</option>
            @for (saList of shipperAuthorization; track saList) {
              <option [ngValue]="saList">
              {{saList}}</option>
            }
          </select>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
          <label class="usa-label">TSP Acceptance </label>
          <select id="pd-hol-tsp-auth" class="maxw-full usa-select" formControlName="pdHolTspAuthorize" [attr.disabled]="isCarrierView?null:true">
            <option value=null selected>None</option>
            @for (tspList of tspAuthorization; track tspList) {
              <option [ngValue]="tspList">
              {{tspList}}</option>
            }
          </select>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
          <label for="pd-hol-other-text-btn" class="usa-label">Message</label>
          <button type="button" class="usa-button" id="pd-hol-other-text-btn" (click)="openAdditionalInfo('Pickup and/or Delivery Saturdays, Sundays or Holidays', 45)">Notes</button>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12 padding-top-2">
          @if (!redirectedFromBol && !isCarrierView) {
            <button type="button" class="usa-button usa-button--secondary" (click)="deleteAccessorialCode('Pickup Delivery Holiday')">Delete</button>
          }
        </div>
      </div>
    </div>
  }
  <!-- END:pickupDeliveryHol -->

  <!-- carrierSuperPersonnel -->
  @if (carrierSuperPersonnelDisplay) {
    <h4 class="usa-accordion__heading">
      <button class="usa-accordion__button" aria-expanded="true" aria-controls="carrierSuperPersonnelDisplay">
        219-Carrier Supervisory Personnel
      </button>
    </h4>
  }
  @if (carrierSuperPersonnelDisplay) {
    <div id="carrierSuperPersonnelDisplay" formGroupName="carrierSuperPersonnel" class="usa-accordion__content usa-prose">
      <div class="grid-row grid-gap-1">
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
          <label for="csp-ship-auth" class="usa-label">Shipper Authorization</label>
          <select id="csp-ship-auth" class="maxw-full usa-select" formControlName="csPersonnelShipAuthorize" [attr.disabled]="!isCarrierView?null:true">
            <option value=null selected>None</option>
            @for (saList of shipperAuthorization; track saList) {
              <option [ngValue]="saList">
              {{saList}}</option>
            }
          </select>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
          <label class="usa-label">TSP Acceptance </label>
          <select id="csp-tsp-auth" class="maxw-full usa-select" formControlName="csPersonnelTspAuthorize" [attr.disabled]="isCarrierView?null:true">
            <option value=null selected>None</option>
            @for (tspList of tspAuthorization; track tspList) {
              <option [ngValue]="tspList">
              {{tspList}}</option>
            }
          </select>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
          <label for="csp-other-text-btn" class="usa-label">Message</label>
          <button type="button" class="usa-button" id="csp-other-text-btn" (click)="openAdditionalInfo('Carrier Supervisory Personnel', 50)">Notes</button>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12 padding-top-2">
          @if (!redirectedFromBol && !isCarrierView) {
            <button type="button" class="usa-button usa-button--secondary" (click)="deleteAccessorialCode('Carrier Supervisor Personnel')">Delete</button>
          }
        </div>
      </div>
    </div>
  }
  <!-- END: carrierSuperPersonnel -->

  <!-- warehousePickUpDelivery -->
  @if (warehousePickUpDeliveryHolDisplay) {
    <h4 class="usa-accordion__heading">
      <button class="usa-accordion__button" aria-expanded="true" aria-controls="warehousePickUpDeliveryHolDisplay">
        225-Warehouse Pickup/Delivery Service
      </button>
    </h4>
  }
  @if (warehousePickUpDeliveryHolDisplay) {
    <div id="warehousePickUpDeliveryHolDisplay" formGroupName="warehousePickUpDelivery" class="usa-accordion__content usa-prose">
      <div class="grid-row grid-gap-1">
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
          <label for="wpd-ship-auth" class="usa-label">Shipper Authorization</label>
          <select id="wpd-ship-auth" class="maxw-full usa-select" formControlName="whPickDelShipAuthorize" [attr.disabled]="!isCarrierView?null:true">
            <option value=null selected>None</option>
            @for (saList of shipperAuthorization; track saList) {
              <option [ngValue]="saList">
              {{saList}}</option>
            }
          </select>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
          <label class="usa-label">TSP Acceptance </label>
          <select id="wpd-tsp-auth" class="maxw-full usa-select" formControlName="whPickDelTspAuthorize" [attr.disabled]="isCarrierView?null:true">
            <option value=null selected>None</option>
            @for (tspList of tspAuthorization; track tspList) {
              <option [ngValue]="tspList">
              {{tspList}}</option>
            }
          </select>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
          <label for="wpd-other-text-btn" class="usa-label">Message</label>
          <button type="button" class="usa-button" id="wpd-other-text-btn" (click)="openAdditionalInfo('Warehouse Pickup/Delivery Service', 51)">Notes</button>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12 padding-top-2">
          @if (!redirectedFromBol && !isCarrierView) {
            <button type="button" class="usa-button usa-button--secondary" (click)="deleteAccessorialCode('Warehouse Pickup Delivery')">Delete</button>
          }
        </div>
      </div>
    </div>
  }
  <!-- END: warehousePickUpDelivery -->

  <!-- otherHhgAccServices -->
  @if (otherHhgAccServicesDisplay) {
    <h4 class="usa-accordion__heading">
      <button class="usa-accordion__button" aria-expanded="true" aria-controls="otherHhgAccServicesDisplay">
        Other HHG Accessorial Charges
      </button>
    </h4>
  }
  @if (otherHhgAccServicesDisplay) {
    <div id="otherHhgAccServicesDisplay" formGroupName="otherHhgAccServices" class="usa-accordion__content usa-prose">
      <div class="grid-row grid-gap-1">
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
          <label for="other-ship-auth" class="usa-label">Shipper Authorization</label>
          <select id="other-ship-auth" class="usa-select maxw-full" formControlName="otherHhgAccSerShipAuthorize">
            <option value=null selected>None</option>
            @for (saList of shipperAuthorization; track saList) {
              <option [ngValue]="saList">
              {{saList}}</option>
            }
          </select>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
          <label class="usa-label">TSP Acceptance </label>
          <select id="other-tsp-auth" class="usa-select maxw-full" formControlName="otherHhgAccSerTspAuthorize">
            <option value=null selected>None</option>
            @for (tspList of tspAuthorization; track tspList) {
              <option [ngValue]="tspList">
              {{tspList}}</option>
            }
          </select>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
          <label for="other-text-btn" class="usa-label">Message</label>
          <button type="button" class="usa-button" id="other-text-btn" (click)="openAdditionalInfo('Other HHG Accessorial Charges', 52)">Notes</button>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12 padding-top-2">
          @if (!redirectedFromBol && !isCarrierView) {
            <button type="button" class="usa-button usa-button--secondary" (click)="deleteAccessorialCode('Other Hhg')">Delete</button>
          }
        </div>
      </div>
    </div>
  }
  <!-- END: otherHhgAccServices -->

  <!-- extraPickUpDelivery -->
  @if (extraPickUpDeliveryDisplay) {
    <h4 class="usa-accordion__heading">
      <button class="usa-accordion__button" aria-expanded="true" aria-controls="extraPickUpDeliveryDisplay">
        28-Extra Pickup/Delivery Address
      </button>
    </h4>
  }
  @if (extraPickUpDeliveryDisplay) {
    <div id="extraPickUpDeliveryDisplay" formGroupName="extraPickUpDelivery" class="usa-accordion__content usa-prose">
      <div class="grid-row grid-gap-1">
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
          <label class="usa-label"> Modify Pickup / Delivery Address</label>
          <button type="button" class="usa-button" (click)="openExtraPickupDeliveryAddress()">Edit</button>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
          <label for="epd-ship-auth" class="usa-label">Shipper Authorization</label>
          <select id="epd-ship-auth" class="maxw-full usa-select" [attr.disabled]="!isCarrierView?null:true" formControlName="extraPickDelShipAuthorize">
            <option value=null selected>None</option>
            @for (saList of shipperAuthorization; track saList) {
              <option [ngValue]="saList">
              {{saList}}</option>
            }
          </select>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
          <label for="epd-other-text-btn" class="usa-label">Message</label>
          <button type="button" class="usa-button" id="epd-other-text-btn" (click)="openAdditionalInfo('Extra Pickup/Delivery Address', 38)">Notes</button>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12 padding-top-2">
          @if (!redirectedFromBol && !isCarrierView) {
            <button type="button" class="usa-button usa-button--secondary" (click)="deleteAccessorialCode('Extra Pickup Delivery')">Delete</button>
          }
        </div>
      </div>
    </div>
  }
  <!-- END:extraPickUpDelivery -->
</div>

@if (!redirectedFromBol) {
  <div class="grid-row padding-y-4">
    <button type="button" class="usa-button" (click)="saveAccessorial()">Save</button>
    <button type="button" class="usa-button usa-button--outline padding-left-2" (click)="goBack()">Back</button>
  </div>
}
</form>
</div>